// extracted by mini-css-extract-plugin
export default {"header":"header_leHSFEMW","box":"box_r7O1IOQK","title":"title_fgLofs8n","link":"link_aUy37LP2","logo":"logo_wt0J8O6i","text":"text_Ml9yWdd2"};